(function() {
    'use strict';

    angular.module('app').factory('HolidayFactory', HolidayFactory);

    function HolidayFactory($resource) {
        return $resource('/holiday/:id', {}, {index: {isArray:true}, update: {method: 'PUT'}});
    }
})();
